import { Box, Button, Menu, MenuItem, Typography } from "@mui/material";
import { HEADER_HEIGHT } from "../../../constants";
import { NavLink } from "react-router-dom";
import { useContext, useState } from "react";
import GlobalContext from "../Context";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";

const OpenIcon = ({ isOpen, ...props }) =>
  isOpen ? <ExpandLess {...props} /> : <ExpandMore {...props} />;

const Header = () => {
  const { userProfile, firebaseService } = useContext(GlobalContext);

  const [anchorEl, setAnchorEl] = useState(null);

  const isOpen = Boolean(anchorEl);

  const handleClick = (e) => {
    setAnchorEl(anchorEl ? null : e.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSignOut = async () => {
    firebaseService.doSignOut();
  };

  const headerStyle = {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: HEADER_HEIGHT,
    zIndex: 1,
    alignItems: "center",
    background: "linear-gradient(90deg, #A7ECD3 0%, #B780FF 100%)",
    display: "flex",
    justifyContent: "space-between",
    paddingLeft: "2rem",
  };

  const navLinkStyle = {
    textDecoration: "none",
    color: "#FFF",
  };

  const titleStyle = {
    fontSize: "1.75rem",
    color: "#FFF",
  };

  const profileButtonStyle = {
    width: "fit-content",
    height: "100%",
    p: "0 2rem",
  };

  const nameStyle = {
    mr: "1rem",
    color: "#FFF",
  };

  const menuStyle = {
    "& .MuiPaper-root": { right: 0 },
  };

  const menuItemStyle = {
    height: "2rem",
    fontSize: "0.875rem",
    justifyContent: "space-between",
  };

  const menuItemIconStyle = {
    fontSize: "0.75rem",
  };

  return (
    <Box component="header" sx={headerStyle}>
      <NavLink to="/" style={navLinkStyle}>
        <Typography variant="h1" sx={titleStyle}>
          API Documentation
        </Typography>
      </NavLink>
      {userProfile?.id && (
        <Box height="100%">
          <Button sx={profileButtonStyle} onClick={handleClick}>
            <Typography variant="h2" sx={nameStyle}>
              {userProfile.name}
            </Typography>
            <OpenIcon isOpen={isOpen} sx={{ color: "#FFF" }} />
          </Button>
          <Menu anchorEl={anchorEl} open={isOpen} onClose={handleClose} sx={menuStyle}>
            <MenuItem onClick={handleSignOut} sx={menuItemStyle}>
              Sign Out
              <ExitToAppIcon sx={menuItemIconStyle} />
            </MenuItem>
          </Menu>
        </Box>
      )}
    </Box>
  );
};

export default Header;
